import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { PATHS, routes } from "../../app/paths";
import { setFloatingWindowOpen } from "./messagingSlice";

export const isMessagingPagePath = (pathname: string) =>
  pathname === PATHS.messaging || pathname.startsWith(`${PATHS.messaging}/`);

export const isMessagingSurfaceVisible = (
  pathname: string,
  isFloatingWindowOpen: boolean,
) => isMessagingPagePath(pathname) || isFloatingWindowOpen;

const useMessagingViewMode = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const minimize = useCallback(() => {
    dispatch(setFloatingWindowOpen(true));
    navigate(routes.home());
  }, [dispatch, navigate]);

  const maximize = useCallback(() => {
    dispatch(setFloatingWindowOpen(false));
    navigate(routes.messaging());
  }, [dispatch, navigate]);

  return { minimize, maximize };
};

export default useMessagingViewMode;
